/**
 * Data-confirmed keyword phrase per test-landing page, used for both the H1
 * (LeanBody.tsx) and the <title> (entry-server.tsx's TEST_LANDING_HEAD) so the
 * two can never drift from each other.
 *
 * Ahrefs research (2026-07) found the generic "{Test} Math Prep" phrasing this
 * site used carries far less real search volume than "{test} practice test" /
 * "{test} math practice" — e.g. "staar math prep" (10/mo) vs "staar practice
 * test" (21,000/mo); "psat math prep" (100/mo) vs "psat practice test"
 * (26,000/mo). Slugs not listed here fall back to `${shortName} Practice
 * Test` in seoPhraseFor() below — every individually-researched test
 * responded well to "practice test" phrasing, so it's a safe default pending
 * a follow-up keyword pull on the remaining tests.
 */
export const SEO_PHRASE_OVERRIDES: Record<string, string> = {
  staar: "STAAR Practice Test",
  "psat-nmsqt": "PSAT Practice Test",
  sat: "SAT Math Practice",
  act: "ACT Math Practice",
  caaspp: "CAASPP Practice Test",
  sbac: "SBAC Practice Test",
  acap: "ACAP Practice Test",
  parcc: "PARCC Practice Test",
  map: "MAP Growth Practice Test",
  "act-aspire": "ACT Aspire Practice Test",
  iready: "i-Ready Practice Test",
};

/** The keyword phrase to use for a test's H1/title. */
export function seoPhraseFor(slug: string, shortName: string): string {
  return SEO_PHRASE_OVERRIDES[slug] ?? `${shortName} Practice Test`;
}
